import { ReactNode } from 'react';
import { BuyerCurrencyGroupWithStats } from '@/enterprise/components/InvoiceCentral/useGroupByBuyerCurrency';

const hasMultipleCurrencies = (makerOrganizationUuid: string, buyers: BuyerCurrencyGroupWithStats[]) => {
  let found = false;
  for (const b of buyers) {
    if (b.makerOrganizationUuid === makerOrganizationUuid) {
      if (found) {
        return true;
      }

      found = true;
    }
  }

  return false;
};

// If multiple elements in buyers array have same makerOrganizationUuid, show currency with name
// Otherwise, just show the maker organization name
export const formatBuyerName = ({
  buyerToFormat,
  buyers,
}: {
  buyerToFormat?: BuyerCurrencyGroupWithStats;
  buyers: BuyerCurrencyGroupWithStats[];
}) => {
  if (!buyerToFormat) {
    return '';
  }

  const { makerOrganizationUuid, currency } = buyerToFormat;

  if (hasMultipleCurrencies(makerOrganizationUuid, buyers)) {
    return `${buyerToFormat.makerOrganizationName} (${currency})`;
  }

  return buyerToFormat.makerOrganizationName || '';
};

// Same as formatBuyerName but renders the currency label with secondary text styling
export const formatBuyerNameJsx = ({
  buyerToFormat,
  buyers,
}: {
  buyerToFormat?: BuyerCurrencyGroupWithStats;
  buyers: BuyerCurrencyGroupWithStats[];
}): ReactNode => {
  if (!buyerToFormat) {
    return '';
  }

  const { makerOrganizationUuid, currency, makerOrganizationName } = buyerToFormat;

  if (hasMultipleCurrencies(makerOrganizationUuid, buyers)) {
    return (
      <>
        {makerOrganizationName} <span className="text-sm text-text-secondary">({currency})</span>
      </>
    );
  }

  return makerOrganizationName || '';
};

// Validate numeric inputs to filters
export const validateNumber = (value: string) => {
  const num = Number(value);
  return !isNaN(num) && num >= 0;
};
